/***
 *  Hasura and GQL specific utils
 **/

export const getLiteralArray = (array: string[]) => {
  // Hasura does not support querying using an array/list as an argument, so need to transform it to a literal object
  return JSON.stringify(array)?.replace("[", "{").replace("]", "}");
};
